import React from 'react';
import { FlameIcon, GlobeIcon } from 'lucide-react';
import { CTAButton, CTA_SUBLABEL } from './CTAButton';
import { Countdown } from './Countdown';
const valueRows = [{
  label: '6 Clinical Volumes',
  value: '$197'
}, {
  label: '5 Exclusive Bonuses',
  value: '$275'
}];
const SPOTS_LEFT = 12;
const SPOTS_TOTAL = 150;
export function Offer() {
  const filled = Math.round((SPOTS_TOTAL - SPOTS_LEFT) / SPOTS_TOTAL * 100);
  return <section id="offer" className="w-full bg-navy-900 px-4 py-12 sm:py-16" data-id="element-142" data-mp="tzd8orw7tsf5">
      <div className="mx-auto w-full max-w-xl" data-id="element-143" data-mp="p0tnitpg4knu">
        <div className="flex justify-center" data-id="element-144" data-mp="p24pcnzbzicb">
          <span className="inline-flex items-center gap-2 rounded-full bg-teal-500/15 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-teal-400" data-id="element-145" data-mp="13y2hlv64w2j9">
            🏆 Special launch offer
          </span>
        </div>
        <h2 className="mt-4 text-center font-display text-[27px] font-black leading-tight text-white sm:text-4xl" data-id="element-146" data-mp="2fad1td6taqc3">
          GLP-1 Clinical Pathway — Complete Package
        </h2>

        <div className="mt-8 rounded-3xl border border-teal-400/25 bg-white p-5 shadow-2xl shadow-black/40 sm:p-6" data-id="element-147" data-mp="pjfi048iobg0">
          <ul className="divide-y divide-navy/10" data-id="element-148" data-mp="uhh1urdroesj">
            {valueRows.map(row => <li key={row.label} className="flex items-center justify-between gap-3 py-3" data-id="element-149" data-mp="ziwlqg47kf9c">
                <span className="text-[14px] font-medium text-navy/75 sm:text-[15px]" data-id="element-150" data-mp="13iow8yd5wvhc">
                  {row.label}
                </span>
                <span className="text-[15px] font-bold text-navy/50 line-through sm:text-base" data-id="element-151" data-mp="6rwk2btcnnku">
                  {row.value}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-3 py-3" data-id="element-152" data-mp="fsb4za2ej0nt">
              <span className="text-[13px] font-extrabold uppercase tracking-wide text-navy sm:text-sm" data-id="element-153" data-mp="klxjl7s4lem9">
                Total value
              </span>
              <span className="text-lg font-black text-navy/50 line-through sm:text-xl" data-id="element-154" data-mp="3o9z775ftw8a0">
                $472 USD
              </span>
            </li>
          </ul>

          <div className="mt-5 rounded-2xl bg-cream p-5 text-center" data-id="element-155" data-mp="vdw7ubkpoyib">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-teal-700" data-id="element-156" data-mp="qfurvzil1fb2">
              Today only
            </p>
            <p className="mt-1 font-display text-[54px] font-black leading-none tracking-tight text-navy sm:text-6xl" data-id="element-157" data-mp="157mynn4b9l16">
              $27
              <span className="align-top text-lg font-bold text-navy/50 sm:text-xl" data-id="element-158" data-mp="cgd1jfpn1tzl"> USD</span>
            </p>
            <p className="mt-2 flex items-center justify-center gap-1.5 text-[12px] font-medium text-navy/60 sm:text-sm" data-id="element-159" data-mp="7il466685fo0">
              <GlobeIcon className="h-4 w-4 text-teal-600" aria-hidden="true" data-id="element-160" data-mp="lj4drhqc8tsa" />
              Pay in your local currency — automatic conversion at checkout
            </p>
          </div>

          <div className="mt-5" data-id="element-161" data-mp="1wvexkyn3tfkl">
            <CTAButton label="Get the Pathway now" sublabel={CTA_SUBLABEL} data-id="element-162" data-mp="1wyszy6vrpos1" />
          </div>

          <div className="mt-5" data-id="element-163" data-mp="1sx7g21ktga8c">
            <Countdown data-id="element-164" data-mp="20ex6txk71lsg" />
          </div>

          <div className="mt-5 rounded-2xl border border-amber-200 bg-amber-50 p-4" data-id="element-165" data-mp="20dul041qa9je">
            <p className="flex items-center justify-between gap-2 text-[12px] font-extrabold uppercase tracking-wide text-amber-800 sm:text-[13px]" data-id="element-166" data-mp="25ery427vsde1">
              <span className="flex items-center gap-1.5" data-id="element-167" data-mp="1qiu9d50aebbu">
                <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-168" data-mp="1vgc862klba64" />
                Promotional price
              </span>
              <span data-id="element-169" data-mp="2j5x0hc2mvjs2">{SPOTS_LEFT} spots left</span>
            </p>
            <div className="mt-2.5 h-3 w-full overflow-hidden rounded-full bg-amber-200/70" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-170" data-mp="2o36qotxujzgy">
              <div className="h-full rounded-full bg-amber-500" style={{
              width: `${filled}%`
            }} data-id="element-171" data-mp="3237scblxraxh" />
            </div>
            <p className="mt-2 text-[11.5px] font-medium leading-snug text-amber-900/80" data-id="element-172" data-mp="1j64lwrn0qbow">
              {SPOTS_TOTAL - SPOTS_LEFT} of {SPOTS_TOTAL} launch spots already claimed. When they
              run out, the price goes back to $197.
            </p>
          </div>
        </div>
      </div>
    </section>;
}